import React, {useEffect, useState} from "react";
import {InputText} from "primereact/inputtext";
import "../Curriculum.css";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {toast} from "react-toastify";
import {Editor} from "primereact/editor";
import {RadioButton} from "primereact/radiobutton";

const OptionForm = (props) => {
    const { index, data = {}, onChange, correctIndex, onSelectCorrect } = props;


    const handleChange = (name, value) => {
        onChange({ ...data, [name]: value }, index);
    };

    const header = (
        <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-strike" aria-label="Strike"></button>
            </span>
    );
    return (
        <div key={`option-${index}`} className="flex flex-row gap-2">
            <RadioButton
                inputId={`option-${index}`}
                name="correctOption"            // tüm grupta aynı isim
                value={index}                   // bu şıkkın değeri
                onChange={(e) => onSelectCorrect(e.value)}
                checked={correctIndex === index}
            />
            <div style={{width: "100%"}}>
                <Editor value={data?.answer}
                        onTextChange={(e) => handleChange("answer", e.htmlValue)}
                        headerTemplate={header}
                        style={{height: '70px', width: '100%', marginBottom: '10px'}}/>
                <InputText name="feedback"
                           value={data?.feedback}
                           type="text" className="inputtext p-inputtext-sm mb-4"
                           placeholder="Bunun neden en iyi cevap olduğunu veya olmadığını açıklayın."
                           onChange={(e) => handleChange("feedback", e.target.value)}
                />
            </div>
        </div>
    )
};

export default OptionForm;
